const PLATFORM_PROFILE_PATTERN = /platform-profile|managing losses|connected accounts/i;

export function formatStripeConnectSetupError(message: string): string {
  if (PLATFORM_PROFILE_PATTERN.test(message)) {
    return (
      'Marketplace Stripe Connect is not fully configured yet. The Worldasia platform owner must open ' +
      'Stripe Dashboard → Settings → Connect → Platform profile, review loss responsibilities, and save. ' +
      'After that, vendors can connect their payout accounts here.'
    );
  }
  return message;
}

export function isStripePlatformProfileError(message: string): boolean {
  return PLATFORM_PROFILE_PATTERN.test(message);
}
